import { DETERMINAR_PAGINA_ATUAL_RESERVA_BPE } from '../types'

export default function determinarPaginaAtualReservaBpe (paginaAtual) {
  return {
    type: DETERMINAR_PAGINA_ATUAL_RESERVA_BPE,
    payload: paginaAtual
  }
}
